import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-ink text-muted2 font-mono text-sm">Authenticating…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
